export default {
    isAuth: !!localStorage.getItem('ucf_token'),
    isLoading: false,
}